import type { RudderAnalytics as TRudderAnalytics } from '@rudderstack/analytics-js';
import { RudderAnalytics as RudderAnalyticsSdk } from '@rudderstack/analytics-js';

// type RudderstackProperties = Record<string, string | number | boolean | RudderstackProperties | null>;
type RudderstackProperties = {
    [k: string]: string | number | boolean | null | RudderstackProperties
};

export function initRudderAnalytics(writeKey: string, dataPlaneUrl: string, configUrl?: string, cdnUrl?: string) {
    if (window.rudderanalytics) {
        console.warn('RudderStack instance initiated twice. Aborting');
        return;
    }

    const rudderAnalyticsSdk = new RudderAnalyticsSdk();
    rudderAnalyticsSdk.load(writeKey, dataPlaneUrl, {
        pluginsSDKBaseURL: cdnUrl,
        storage: {
            encryption: {
                version: 'legacy',
            },
            migrate: false,
        },
        plugins: [ 'GoogleLinker', 'NativeDestinationQueue', 'StorageEncryptionLegacy', 'StorageEncryption', 'StorageMigrator', 'DeviceModeDestinations' ],
        configUrl,
    });

    window.rudderanalytics = rudderAnalyticsSdk;
}

export function rudderAnalytics(rudderStackFn: (rs: TRudderAnalytics) => void) : void {
    try {
        if (window.rudderanalytics) {
            rudderStackFn(window.rudderanalytics);
        }
    } catch (e) {
        console.error('Error in rudderanalytics call', e);
    }
}
export function rudderAnalyticsTrack(
    event: string,
    properties?: RudderstackProperties,
) : void {
    rudderAnalytics((rs) => rs.track(event, properties));
}

export function rudderAnalyticsPage(
    category: string,
    name: string,
    properties?: RudderstackProperties,
) : void {
    rudderAnalytics((rs) => rs.page(category, name, properties));
}

export function rudderAnalyticsIdentify(
    userId: string,
    properties?: RudderstackProperties,
) : void {
    rudderAnalytics((rs) => rs.identify(userId, properties));
}

export function rudderAnalyticsAnonymousIdFromHash(): string | null {
    const regex = /eaid=([^&]*)/;
    const hashMatches = window.location.hash.match(regex);
    return hashMatches ? hashMatches[1] : null;
}
